import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import MiniLQ from '../mini-lq';
import { Flowtype, LQ_VIEWS, Platforms } from '../../constants/common';
import { stickyBannerContent } from '../../constants/lq-constants';
import { getCurrentDocument } from '../../utils/helperUtil';
import { addListener, removeListener } from './taggingHelper';

const MiniLQStandAlone = (props) => {
  console.log('...props', props);
  const addressQualification = useSelector((state) => state.addressQualification);
  const customerStreetDetails = useSelector((state) => state.customerStreetDetails);
  const addressLookup = useSelector((state) => state.addressLookup);
  const revisitAddress = addressLookup?.revisitAddress;
  const loopQualApp = useSelector((state) => state.loopQualApp);
  const unitLookup = useSelector((state) => state.unitLookup);
  const modalOverlay = useSelector((state) => state.modalOverlay);
  const fiosDetails = useSelector((state) => state.fiosDetails);
  const multiServiceDetails = useSelector((state) => state.multiServiceDetails);
  const sessionTimeout = useSelector((state) => state.sessionTimeout);
  const moveDetails = useSelector((state) => state.moveDetails);
  const notify = useSelector((state) => state.notify);
  const bulkQualDetails = useSelector((state) => state.bulkQualDetails);
  // const { stickyBannerContent } = props;
  const getLQResult = addressQualification?.lqResult;
  const getAddress = useMemo(
    () =>
      getLQResult?.lqAddress && getLQResult?.lqAddress.length > 4
        ? getLQResult.lqAddress
        : customerStreetDetails && customerStreetDetails.disprawstr
        ? customerStreetDetails.disprawstr
        : revisitAddress,
    [getLQResult, customerStreetDetails, revisitAddress],
  );
  const renderContent = () => {
    let content = stickyBannerContent.default;
    if (loopQualApp.flowType === Flowtype.MOVERS) {
      content = stickyBannerContent.default;
    } else if (loopQualApp.isLoggedIn && loopQualApp.currentLQView === LQ_VIEWS.BULK_SERVICES_QUALIFIED_VIEW) {
      content = stickyBannerContent.default_bulk;
    } else if (loopQualApp.widgetHost === '5g') {
      content = stickyBannerContent.default_5g;
    } else if (loopQualApp.widgetHost === 'lte') {
      content = stickyBannerContent.default_lte;
    } else if (loopQualApp.widgetHost === 'fios' || loopQualApp.lqPlatform === Platforms.FIOS) {
      content = stickyBannerContent.default_fios;
    }
    return content;
  };
  const frameObj = {
    loopQualApp,
    customerStreetDetails: addressLookup.customerStreetDetails,
    revisitAddress: addressLookup.revisitAddress,
    streetInput: addressLookup.streetInput,
    addressLookup,
    unitInputError: unitLookup.unitInputError,
    unitLookupDetails: unitLookup,
    addressQualification,
    modalOverlay,
    lqResult: addressQualification.lqResult || {},
    multiServiceDetails,
    isLoggedIn: loopQualApp.isLoggedIn,
    fiosDetails,
    moveDetails,
    notify,
    bulkQualDetails,
    parserAttempt: addressLookup.parserAttempt,
    sessionTimeout,
    lqAddress: getAddress,
    displayContent: renderContent(),
  };

  useEffect(() => {
    const getDocument = getCurrentDocument();
    const allElements = getDocument.querySelectorAll('[data-track]');
    addListener(allElements);
    return () => {
      removeListener(allElements);
    };
  });
  return (
    <>
      <MiniLQ {...props} {...frameObj} />
    </>
  );
};

export default MiniLQStandAlone;
